import * as MD from '@material-ui/core';
import { Autocomplete, AutocompleteRenderInputParams } from '@material-ui/lab/';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import { IApplicationState, IConnectedReduxProps } from '../../Store';
import {
	getAllMedias,
	setAllChannelsFilter,
} from '../../Store/AppsManagement/Actions';
import {
	IAppsManagementState,
	IChannelSearchParams,
	Media,
} from '../../Store/AppsManagement/Types';
import { I18N, ILocaleInfos } from '../../Store/I18n/Types';
import { ILayoutState } from '../../Store/Layout/Types';
import { IUserState } from '../../Store/User/Types';
import { getTheme } from '../../Themes';
import {
	isNullOrUndefined,
	isNullOrUndefinedOrEmptyString,
} from '../../Utils/Various';

export interface IRouterMatchParams {
	groupName: string;
	type: string;
}

interface IPropsFromState {
	i18n: I18N;
	layout: ILayoutState;
	localeInfos: ILocaleInfos;
	router: RouteComponentProps<IRouterMatchParams>;
	user: IUserState;
	appsManagement: IAppsManagementState;
}

interface IState {
	params: IChannelSearchParams;
}

interface IPropsTheme {
	theme: any;
}

interface IPropsFromDispatch {
	getAllMedias: typeof getAllMedias;
	setAllChannelsFilter: typeof setAllChannelsFilter;
}

type AllProps = MD.WithStyles<typeof styles> &
	IPropsFromState &
	IPropsFromDispatch &
	RouteComponentProps<{}> &
	IPropsTheme &
	IConnectedReduxProps;

const theme = getTheme();
const styles = MD.createStyles({
	drawerChannelPaper: {
		width: theme.UserManagement.dimensions.drawerWidth,
		paddingTop: '14px',
		paddingLeft: '15px',
		paddingRight: '15px',
		backgroundColor: theme.palette.background.default,
	},
	launchSearch: {
		marginTop: '20px',
	},
	formControl: {
		margin: theme.spacing(3),
	},
	formLabel: {
		marginBottom: theme.spacing(2),
	},
});

export class DrawerChannelComponent extends React.Component<AllProps, IState> {
	private switchTimer = -1;

	public constructor(props: AllProps) {
		super(props);
		this.state = {
			params: {
				isencoded: null,
				firstChunkCompare: null,
				isFirstChunkBefore: null,
				isFirstChunkAfter: null,
				id: null,
				isIdEqual: null,
				isIdDifferent: null,
				isIdContained: null,
				lastChunkCompare: null,
				isLastChunkBefore: null,
				isLastChunkAfter: null,
				mediaSource: null,
				mediaSourceDuplicate: null,
				isMediaSourceEqual: null,
				isMediaSourceDifferent: null,
				isMediaSourceContained: null,
				type: null,
				isTypeTV: null,
				isTypeRadio: null,
				name: null,
				isNameEqual: null,
				isNameDifferent: null,
				isNameContained: null,
			},
		};
	}

	public componentDidUpdate(prevProps: AllProps, prevState: IState) {
		if (this.switchTimer !== -1) {
			window.clearTimeout(this.switchTimer);
		}
		this.switchTimer = window.setTimeout(() => {
			if (prevState.params !== this.state.params) {
				this.props.setAllChannelsFilter(this.state.params);
			}
			this.switchTimer = -1;
		}, 300);
	}

	public render(): React.ReactNode {
		return (
			<MD.FormGroup>
				<Autocomplete
					id="combo-box-parent"
					options={this.getPossibleMedias()}
					onChange={(ev: React.ChangeEvent<{}>, val: any) => {
						if (
							!isNullOrUndefined(val) &&
							!isNullOrUndefinedOrEmptyString(val.name)
						) {
							this.setState({
								params: {
									...this.state.params,
									isencoded: val.encoding,
									firstChunkCompare: val.firstChunk,
									id: val.id,
									lastChunkCompare: val.lastChunk,
									mediaSource: val.mediaSource,
									mediaSourceDuplicate: null,
									type: val.type,
									name: val.name,
									isFirstChunkBefore:
										this.state.params.isFirstChunkBefore ===
										null
											? true
											: this.state.params
													.isFirstChunkBefore,
									isFirstChunkAfter:
										this.state.params.isFirstChunkAfter ===
										null
											? true
											: this.state.params
													.isFirstChunkAfter,
									isIdEqual:
										this.state.params.isIdEqual === null
											? true
											: this.state.params.isIdEqual,
									isIdDifferent:
										this.state.params.isIdDifferent === null
											? false
											: this.state.params.isIdDifferent,
									isIdContained:
										this.state.params.isIdContained === null
											? false
											: this.state.params.isIdContained,
									isLastChunkBefore:
										this.state.params.isLastChunkBefore ===
										null
											? true
											: this.state.params
													.isLastChunkBefore,
									isLastChunkAfter:
										this.state.params.isLastChunkAfter ===
										null
											? true
											: this.state.params
													.isLastChunkAfter,
									isMediaSourceEqual:
										this.state.params.isMediaSourceEqual ===
										null
											? true
											: this.state.params
													.isMediaSourceEqual,
									isMediaSourceDifferent:
										this.state.params
											.isMediaSourceDifferent === null
											? true
											: this.state.params
													.isMediaSourceDifferent,
									isMediaSourceContained:
										this.state.params
											.isMediaSourceContained === null
											? true
											: this.state.params
													.isMediaSourceContained,
									isTypeTV:
										this.state.params.isTypeTV === null
											? true
											: this.state.params.type === 2,
									isTypeRadio:
										this.state.params.isTypeRadio === null
											? false
											: this.state.params.type === 1,
									isNameEqual:
										this.state.params.isNameEqual === null
											? true
											: this.state.params.isNameEqual,
									isNameDifferent:
										this.state.params.isNameDifferent ===
										null
											? false
											: this.state.params.isNameDifferent,
									isNameContained:
										this.state.params.isNameContained ===
										null
											? false
											: this.state.params.isNameContained,
								},
							});
						}
					}}
					getOptionLabel={(option) => option.name}
					renderInput={(params: AutocompleteRenderInputParams) => (
						<MD.TextField
							{...params}
							label={this.props.i18n._('Channel')}
							value={this.state.params.name}
						/>
					)}
				/>

				<MD.FormControlLabel
					control={
						<MD.Switch
							checked={
								this.state.params.isencoded === null
									? false
									: this.state.params.isencoded
							}
							onChange={(
								event: React.ChangeEvent<HTMLInputElement>
							) => {
								this.setState({
									...this.state,
									params: {
										...this.state.params,
										isencoded: event.target.checked,
									},
								});
							}}
							name="isEncoded"
						/>
					}
					label="Show only encoded channels"
				/>

				{this.state.params.mediaSourceDuplicate === null ? (
					<MD.FormControlLabel
						control={
							<MD.Checkbox
								checked={
									this.state.params.mediaSourceDuplicate !==
									null
								}
								onChange={() => {
									this.state.params.mediaSourceDuplicate ===
									null
										? this.setState({
												...this.state,
												params: {
													...this.state.params,
													mediaSourceDuplicate: true,
												},
										  })
										: this.setState({
												...this.state,
												params: {
													...this.state.params,
													mediaSourceDuplicate: null,
												},
										  });
								}}
								name="filterencoding"
								color="primary"
							/>
						}
						label="Media Source Duplicate"
					/>
				) : (
					[
						<MD.FormControlLabel
							control={
								<MD.Checkbox
									checked={
										this.state.params
											.mediaSourceDuplicate !== null
									}
									onChange={() => {
										this.state.params
											.mediaSourceDuplicate === null
											? this.setState({
													...this.state,
													params: {
														...this.state.params,
														mediaSourceDuplicate:
															true,
													},
											  })
											: this.setState({
													...this.state,
													params: {
														...this.state.params,
														mediaSourceDuplicate:
															null,
													},
											  });
									}}
									name="filterencoding"
									color="primary"
								/>
							}
							label="Media Source Duplicate"
						/>,

						<MD.FormControlLabel
							control={
								<MD.Switch
									checked={
										this.state.params.mediaSourceDuplicate
									}
									onChange={(
										event: React.ChangeEvent<HTMLInputElement>
									) => {
										this.setState({
											...this.state,
											params: {
												...this.state.params,
												mediaSourceDuplicate:
													event.target.checked,
											},
										});
									}}
									name="isDups"
								/>
							}
							label={'Remove duplicate'}
						/>,

						<MD.FormControlLabel
							control={
								<MD.Switch
									checked={
										!this.state.params.mediaSourceDuplicate
									}
									onChange={(
										event: React.ChangeEvent<HTMLInputElement>
									) => {
										this.setState({
											...this.state,
											params: {
												...this.state.params,
												mediaSourceDuplicate:
													!event.target.checked,
											},
										});
									}}
									name="isDups"
								/>
							}
							label={'Show only duplicate'}
						/>,
					]
				)}

				{this.state.params.name === null ? (
					<MD.FormControlLabel
						control={
							<MD.Checkbox
								checked={this.state.params.name !== null}
								onChange={() => {
									this.state.params.name === null
										? this.setState({
												...this.state,
												params: {
													...this.state.params,
													name: '',
													isNameContained: true,
													isNameDifferent: false,
													isNameEqual: false,
												},
										  })
										: this.setState({
												...this.state,
												params: {
													...this.state.params,

													name: null,
													isNameContained: null,
													isNameDifferent: null,
													isNameEqual: null,
												},
										  });
								}}
								name="filterName"
								color="primary"
							/>
						}
						label="Filter on channel name"
					/>
				) : (
					[
						<MD.FormControlLabel
							control={
								<MD.Checkbox
									checked={this.state.params.name !== null}
									onChange={() => {
										this.state.params.name === null
											? this.setState({
													...this.state,
													params: {
														...this.state.params,
														name: '',
														isNameContained: true,
														isNameDifferent: false,
														isNameEqual: false,
													},
											  })
											: this.setState({
													...this.state,
													params: {
														...this.state.params,
														name: null,
														isNameContained: null,
														isNameDifferent: null,
														isNameEqual: null,
													},
											  });
									}}
									name="filterencoding"
									color="primary"
								/>
							}
							label="Filter on channel name"
						/>,

						<MD.TextField
							id="textfield-Name"
							label="FirstChunk"
							InputLabelProps={{
								shrink: true,
							}}
							value={this.state.params.name}
							onChange={(
								ev: React.ChangeEvent<
									HTMLTextAreaElement | HTMLInputElement
								>
							) => {
								this.setState({
									...this.state,
									params: {
										...this.state.params,
										name: ev.target.value,
									},
								});
							}}
						/>,
						<MD.FormControlLabel
							control={
								<MD.Switch
									checked={
										this.state.params.isNameEqual === null
											? true
											: this.state.params.isNameEqual
									}
									onChange={(
										event: React.ChangeEvent<HTMLInputElement>
									) => {
										if (event.target.checked) {
											this.setState({
												...this.state,
												params: {
													...this.state.params,
													isNameEqual:
														event.target.checked,
													isNameContained: false,
													isNameDifferent: false,
												},
											});
										} else {
											if (
												this.state.params
													.isNameDifferent === true ||
												this.state.params
													.isNameContained === true
											) {
												this.setState({
													...this.state,
													params: {
														...this.state.params,
														isNameEqual:
															event.target
																.checked,
													},
												});
											}
										}
									}}
									name="Nameequal"
								/>
							}
							label="Name is equal"
						/>,
						<MD.FormControlLabel
							control={
								<MD.Switch
									checked={
										this.state.params.isNameContained ===
										null
											? true
											: this.state.params.isNameContained
									}
									onChange={(
										event: React.ChangeEvent<HTMLInputElement>
									) => {
										if (event.target.checked) {
											this.setState({
												...this.state,
												params: {
													...this.state.params,
													isNameContained:
														event.target.checked,
													isNameDifferent: false,
													isNameEqual: false,
												},
											});
										} else {
											if (
												this.state.params
													.isNameDifferent === true ||
												this.state.params
													.isNameEqual === true
											) {
												this.setState({
													...this.state,
													params: {
														...this.state.params,
														isNameContained:
															event.target
																.checked,
													},
												});
											}
										}
									}}
									name="Namecontained"
								/>
							}
							label="Name is contained"
						/>,
						<MD.FormControlLabel
							control={
								<MD.Switch
									checked={
										this.state.params.isNameDifferent ===
										null
											? true
											: this.state.params.isNameDifferent
									}
									onChange={(
										event: React.ChangeEvent<HTMLInputElement>
									) => {
										if (event.target.checked) {
											this.setState({
												...this.state,
												params: {
													...this.state.params,
													isNameDifferent:
														event.target.checked,
													isNameContained: false,
													isNameEqual: false,
												},
											});
										} else {
											if (
												this.state.params
													.isNameEqual === true ||
												this.state.params
													.isNameContained === true
											) {
												this.setState({
													...this.state,
													params: {
														...this.state.params,
														isNameDifferent:
															event.target
																.checked,
													},
												});
											}
										}
									}}
									name="Namediff"
								/>
							}
							label="Name is different"
						/>,
					]
				)}

				{this.state.params.type === null ? (
					<MD.FormControlLabel
						control={
							<MD.Checkbox
								checked={this.state.params.type !== null}
								onChange={() => {
									this.state.params.type === null
										? this.setState({
												...this.state,
												params: {
													...this.state.params,
													type: 0,
													isTypeRadio: true,
													isTypeTV: true,
												},
										  })
										: this.setState({
												...this.state,
												params: {
													...this.state.params,
													type: null,
												},
										  });
								}}
								name="filtertype"
								color="primary"
							/>
						}
						label="Filter on type"
					/>
				) : (
					[
						<MD.FormControlLabel
							control={
								<MD.Checkbox
									checked={this.state.params.type !== null}
									onChange={() => {
										this.state.params.type === null
											? this.setState({
													...this.state,
													params: {
														...this.state.params,
														type: 0,
														isTypeRadio: true,
														isTypeTV: true,
													},
											  })
											: this.setState({
													...this.state,
													params: {
														...this.state.params,
														type: null,
													},
											  });
									}}
									name="filtertype"
									color="primary"
								/>
							}
							label="Filter on type"
						/>,

						<MD.FormControlLabel
							control={
								<MD.Switch
									checked={
										this.state.params.isTypeTV === null
											? false
											: this.state.params.isTypeTV
									}
									onChange={(
										event: React.ChangeEvent<HTMLInputElement>
									) => {
										this.setState({
											...this.state,
											params: {
												...this.state.params,
												isTypeTV: event.target.checked,
											},
										});
									}}
									name="isTV"
								/>
							}
							label="TV"
						/>,
						<MD.FormControlLabel
							control={
								<MD.Switch
									checked={
										this.state.params.isTypeRadio === null
											? false
											: this.state.params.isTypeRadio
									}
									onChange={(
										event: React.ChangeEvent<HTMLInputElement>
									) => {
										this.setState({
											...this.state,
											params: {
												...this.state.params,
												isTypeRadio:
													event.target.checked,
											},
										});
									}}
									name="isRadio"
								/>
							}
							label="Radio"
						/>,
					]
				)}

				{this.state.params.id === null ? (
					<MD.FormControlLabel
						control={
							<MD.Checkbox
								checked={this.state.params.id !== null}
								onChange={() => {
									this.state.params.id === null
										? this.setState({
												...this.state,
												params: {
													...this.state.params,
													id: 0,
													isIdContained: false,
													isIdDifferent: false,
													isIdEqual: true,
												},
										  })
										: this.setState({
												...this.state,
												params: {
													...this.state.params,

													id: null,
													isIdContained: null,
													isIdDifferent: null,
													isIdEqual: null,
												},
										  });
								}}
								name="filterencoding"
								color="primary"
							/>
						}
						label="Filter on ID"
					/>
				) : (
					[
						<MD.FormControlLabel
							control={
								<MD.Checkbox
									checked={this.state.params.id !== null}
									onChange={() => {
										this.state.params.id === null
											? this.setState({
													...this.state,
													params: {
														...this.state.params,
														id: 0,
														isIdContained: false,
														isIdDifferent: false,
														isIdEqual: true,
													},
											  })
											: this.setState({
													...this.state,
													params: {
														...this.state.params,
														id: null,
														isIdContained: null,
														isIdDifferent: null,
														isIdEqual: null,
													},
											  });
									}}
									name="filterencoding"
									color="primary"
								/>
							}
							label="Filter on ID"
						/>,

						<MD.TextField
							id="textfield-id"
							label="FirstChunk"
							type="number"
							InputLabelProps={{
								shrink: true,
							}}
							value={this.state.params.id}
							onChange={(
								ev: React.ChangeEvent<
									HTMLTextAreaElement | HTMLInputElement
								>
							) => {
								if (!isNaN(parseInt(ev.target.value))) {
									this.setState({
										...this.state,
										params: {
											...this.state.params,
											id: parseInt(ev.target.value),
										},
									});
								}
							}}
						/>,
						<MD.FormControlLabel
							control={
								<MD.Switch
									checked={
										this.state.params.isIdEqual === null
											? true
											: this.state.params.isIdEqual
									}
									onChange={(
										event: React.ChangeEvent<HTMLInputElement>
									) => {
										if (event.target.checked) {
											this.setState({
												...this.state,
												params: {
													...this.state.params,
													isIdEqual:
														event.target.checked,
													isIdContained: false,
													isIdDifferent: false,
												},
											});
										} else {
											if (
												this.state.params
													.isIdDifferent === true ||
												this.state.params
													.isIdContained === true
											) {
												this.setState({
													...this.state,
													params: {
														...this.state.params,
														isIdEqual:
															event.target
																.checked,
													},
												});
											}
										}
									}}
									name="idequal"
								/>
							}
							label="ID is equal"
						/>,
						<MD.FormControlLabel
							control={
								<MD.Switch
									checked={
										this.state.params.isIdContained === null
											? true
											: this.state.params.isIdContained
									}
									onChange={(
										event: React.ChangeEvent<HTMLInputElement>
									) => {
										if (event.target.checked) {
											this.setState({
												...this.state,
												params: {
													...this.state.params,
													isIdContained:
														event.target.checked,
													isIdDifferent: false,
													isIdEqual: false,
												},
											});
										} else {
											if (
												this.state.params
													.isIdDifferent === true ||
												this.state.params.isIdEqual ===
													true
											) {
												this.setState({
													...this.state,
													params: {
														...this.state.params,
														isIdContained:
															event.target
																.checked,
													},
												});
											}
										}
									}}
									name="idcontained"
								/>
							}
							label="ID is contained"
						/>,
						<MD.FormControlLabel
							control={
								<MD.Switch
									checked={
										this.state.params.isIdDifferent === null
											? true
											: this.state.params.isIdDifferent
									}
									onChange={(
										event: React.ChangeEvent<HTMLInputElement>
									) => {
										if (event.target.checked) {
											this.setState({
												...this.state,
												params: {
													...this.state.params,
													isIdDifferent:
														event.target.checked,
													isIdContained: false,
													isIdEqual: false,
												},
											});
										} else {
											if (
												this.state.params.isIdEqual ===
													true ||
												this.state.params
													.isIdContained === true
											) {
												this.setState({
													...this.state,
													params: {
														...this.state.params,
														isIdDifferent:
															event.target
																.checked,
													},
												});
											}
										}
									}}
									name="iddiff"
								/>
							}
							label="ID is different"
						/>,
					]
				)}
				{this.state.params.mediaSource === null ? (
					<MD.FormControlLabel
						control={
							<MD.Checkbox
								checked={this.state.params.mediaSource !== null}
								onChange={() => {
									this.state.params.mediaSource === null
										? this.setState({
												...this.state,
												params: {
													...this.state.params,
													mediaSource: 0,
													isMediaSourceContained:
														false,
													isMediaSourceDifferent:
														false,
													isMediaSourceEqual: true,
												},
										  })
										: this.setState({
												...this.state,
												params: {
													...this.state.params,

													mediaSource: null,
													isMediaSourceContained:
														null,
													isMediaSourceDifferent:
														null,
													isMediaSourceEqual: null,
												},
										  });
								}}
								name="filterMediaSource"
								color="primary"
							/>
						}
						label="Filter on Media Source"
					/>
				) : (
					[
						<MD.FormControlLabel
							control={
								<MD.Checkbox
									checked={
										this.state.params.mediaSource !== null
									}
									onChange={() => {
										this.state.params.mediaSource === null
											? this.setState({
													...this.state,
													params: {
														...this.state.params,
														mediaSource: 0,
														isMediaSourceContained:
															false,
														isMediaSourceDifferent:
															false,
														isMediaSourceEqual:
															true,
													},
											  })
											: this.setState({
													...this.state,
													params: {
														...this.state.params,
														mediaSource: null,
														isMediaSourceContained:
															null,
														isMediaSourceDifferent:
															null,
														isMediaSourceEqual:
															null,
													},
											  });
									}}
									name="filterencoding"
									color="primary"
								/>
							}
							label="Filter on Media Source"
						/>,

						<MD.TextField
							id="textfield-MediaSource"
							label="FirstChunk"
							type="number"
							InputLabelProps={{
								shrink: true,
							}}
							value={this.state.params.mediaSource}
							onChange={(
								ev: React.ChangeEvent<
									HTMLTextAreaElement | HTMLInputElement
								>
							) => {
								if (!isNaN(parseInt(ev.target.value))) {
									this.setState({
										...this.state,
										params: {
											...this.state.params,
											mediaSource: parseInt(
												ev.target.value
											),
										},
									});
								}
							}}
						/>,
						<MD.FormControlLabel
							control={
								<MD.Switch
									checked={
										this.state.params.isMediaSourceEqual ===
										null
											? true
											: this.state.params
													.isMediaSourceEqual
									}
									onChange={(
										event: React.ChangeEvent<HTMLInputElement>
									) => {
										if (event.target.checked) {
											this.setState({
												...this.state,
												params: {
													...this.state.params,
													isMediaSourceEqual:
														event.target.checked,
													isMediaSourceContained:
														false,
													isMediaSourceDifferent:
														false,
												},
											});
										} else {
											if (
												this.state.params
													.isMediaSourceDifferent ===
													true ||
												this.state.params
													.isMediaSourceContained ===
													true
											) {
												this.setState({
													...this.state,
													params: {
														...this.state.params,
														isMediaSourceEqual:
															event.target
																.checked,
													},
												});
											}
										}
									}}
									name="MediaSourceequal"
								/>
							}
							label="Media Source is equal"
						/>,
						<MD.FormControlLabel
							control={
								<MD.Switch
									checked={
										this.state.params
											.isMediaSourceContained === null
											? true
											: this.state.params
													.isMediaSourceContained
									}
									onChange={(
										event: React.ChangeEvent<HTMLInputElement>
									) => {
										if (event.target.checked) {
											this.setState({
												...this.state,
												params: {
													...this.state.params,
													isMediaSourceContained:
														event.target.checked,
													isMediaSourceDifferent:
														false,
													isMediaSourceEqual: false,
												},
											});
										} else {
											if (
												this.state.params
													.isMediaSourceDifferent ===
													true ||
												this.state.params
													.isMediaSourceEqual === true
											) {
												this.setState({
													...this.state,
													params: {
														...this.state.params,
														isMediaSourceContained:
															event.target
																.checked,
													},
												});
											}
										}
									}}
									name="MediaSourcecontained"
								/>
							}
							label="Media Source is contained"
						/>,
						<MD.FormControlLabel
							control={
								<MD.Switch
									checked={
										this.state.params
											.isMediaSourceDifferent === null
											? true
											: this.state.params
													.isMediaSourceDifferent
									}
									onChange={(
										event: React.ChangeEvent<HTMLInputElement>
									) => {
										if (event.target.checked) {
											this.setState({
												...this.state,
												params: {
													...this.state.params,
													isMediaSourceDifferent:
														event.target.checked,
													isMediaSourceContained:
														false,
													isMediaSourceEqual: false,
												},
											});
										} else {
											if (
												this.state.params
													.isMediaSourceEqual ===
													true ||
												this.state.params
													.isMediaSourceContained ===
													true
											) {
												this.setState({
													...this.state,
													params: {
														...this.state.params,
														isMediaSourceDifferent:
															event.target
																.checked,
													},
												});
											}
										}
									}}
									name="MediaSourcediff"
								/>
							}
							label="Media Source is different"
						/>,
					]
				)}

				{this.state.params.firstChunkCompare === null ? (
					<MD.FormControlLabel
						control={
							<MD.Checkbox
								checked={
									this.state.params.firstChunkCompare !== null
								}
								onChange={() => {
									this.state.params.firstChunkCompare === null
										? this.setState({
												...this.state,
												params: {
													...this.state.params,
													firstChunkCompare: 0,
												},
										  })
										: this.setState({
												...this.state,
												params: {
													...this.state.params,
													firstChunkCompare: 0,
												},
										  });
								}}
								name="filterencoding"
								color="primary"
							/>
						}
						label="Filter on first chunk"
					/>
				) : (
					[
						<MD.FormControlLabel
							control={
								<MD.Checkbox
									checked={
										this.state.params.firstChunkCompare !==
										null
									}
									onChange={() => {
										this.state.params.firstChunkCompare ===
										null
											? this.setState({
													...this.state,
													params: {
														...this.state.params,
														firstChunkCompare: 0,
													},
											  })
											: this.setState({
													...this.state,
													params: {
														...this.state.params,
														firstChunkCompare: null,
													},
											  });
									}}
									name="filterencoding"
									color="primary"
								/>
							}
							label="Filter on first chunk"
						/>,
						<MD.TextField
							id="datetime-local"
							label="FirstChunk"
							type="date"
							InputLabelProps={{
								shrink: true,
							}}
							value={
								new Date(this.state.params.firstChunkCompare)
									.toISOString()
									.split('T')[0]
							}
							onChange={(
								ev: React.ChangeEvent<
									HTMLTextAreaElement | HTMLInputElement
								>
							) => {
								if (!isNaN(Date.parse(ev.target.value))) {
									this.setState({
										...this.state,
										params: {
											...this.state.params,
											firstChunkCompare: Date.parse(
												ev.target.value
											),
										},
									});
								}
							}}
						/>,
						<MD.FormControlLabel
							control={
								<MD.Switch
									checked={
										this.state.params.isFirstChunkAfter ===
										null
											? true
											: this.state.params
													.isFirstChunkAfter
									}
									onChange={(
										event: React.ChangeEvent<HTMLInputElement>
									) => {
										this.setState({
											...this.state,
											params: {
												...this.state.params,
												isFirstChunkAfter:
													event.target.checked,
											},
										});
									}}
									name="isEncoded"
								/>
							}
							label="First chunk after"
						/>,
						<MD.FormControlLabel
							control={
								<MD.Switch
									checked={
										this.state.params.isFirstChunkBefore ===
										null
											? true
											: this.state.params
													.isFirstChunkBefore
									}
									onChange={(
										event: React.ChangeEvent<HTMLInputElement>
									) => {
										this.setState({
											...this.state,
											params: {
												...this.state.params,
												isFirstChunkBefore:
													event.target.checked,
											},
										});
									}}
									name="isEncoded"
								/>
							}
							label="First chunk before"
						/>,
					]
				)}
				{this.state.params.lastChunkCompare === null ? (
					<MD.FormControlLabel
						control={
							<MD.Checkbox
								checked={
									this.state.params.lastChunkCompare !== null
								}
								onChange={() => {
									this.state.params.lastChunkCompare === null
										? this.setState({
												...this.state,
												params: {
													...this.state.params,
													lastChunkCompare: 0,
												},
										  })
										: this.setState({
												...this.state,
												params: {
													...this.state.params,
													lastChunkCompare: 0,
												},
										  });
								}}
								name="filterencoding"
								color="primary"
							/>
						}
						label="Filter on last chunk"
					/>
				) : (
					[
						<MD.FormControlLabel
							control={
								<MD.Checkbox
									checked={
										this.state.params.lastChunkCompare !==
										null
									}
									onChange={() => {
										this.state.params.lastChunkCompare ===
										null
											? this.setState({
													...this.state,
													params: {
														...this.state.params,
														lastChunkCompare: 0,
													},
											  })
											: this.setState({
													...this.state,
													params: {
														...this.state.params,
														lastChunkCompare: null,
													},
											  });
									}}
									name="filterencoding"
									color="primary"
								/>
							}
							label="Filter on last chunk"
						/>,
						<MD.TextField
							id="datetime-local"
							label="FirstChunk"
							type="date"
							InputLabelProps={{
								shrink: true,
							}}
							value={
								new Date(this.state.params.lastChunkCompare)
									.toISOString()
									.split('T')[0]
							}
							onChange={(
								ev: React.ChangeEvent<
									HTMLTextAreaElement | HTMLInputElement
								>
							) => {
								if (!isNaN(Date.parse(ev.target.value))) {
									this.setState({
										...this.state,
										params: {
											...this.state.params,
											lastChunkCompare: Date.parse(
												ev.target.value
											),
										},
									});
								}
							}}
						/>,
						<MD.FormControlLabel
							control={
								<MD.Switch
									checked={
										this.state.params.isLastChunkAfter ===
										null
											? true
											: this.state.params.isLastChunkAfter
									}
									onChange={(
										event: React.ChangeEvent<HTMLInputElement>
									) => {
										this.setState({
											...this.state,
											params: {
												...this.state.params,
												isLastChunkAfter:
													event.target.checked,
											},
										});
									}}
									name="isEncoded"
								/>
							}
							label="Last chunk after"
						/>,
						<MD.FormControlLabel
							control={
								<MD.Switch
									checked={
										this.state.params.isLastChunkBefore ===
										null
											? true
											: this.state.params
													.isLastChunkBefore
									}
									onChange={(
										event: React.ChangeEvent<HTMLInputElement>
									) => {
										this.setState({
											...this.state,
											params: {
												...this.state.params,
												isLastChunkBefore:
													event.target.checked,
											},
										});
									}}
									name="isEncoded"
								/>
							}
							label="Last chunk before"
						/>,
					]
				)}
			</MD.FormGroup>
		);
	}

	private getPossibleMedias(): Media[] {
		const parents = [...this.props.appsManagement.allMedias];
		return parents;
	}
}

const mapStateToProps = (
	{ i18n, layout, router, user, appsManagement }: IApplicationState,
	ownProps: RouteComponentProps<IRouterMatchParams>
) => ({
	i18n: i18n.i18n,
	localeInfos: i18n.localeInfos,
	layout,
	router: ownProps,
	user,
	appsManagement,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	getAllMedias: () => dispatch(getAllMedias()),
	setAllChannelsFilter: (filter: IChannelSearchParams) =>
		dispatch(setAllChannelsFilter(filter)),
});

export const DrawerChannel = connect(
	mapStateToProps,
	mapDispatchToProps
)(MD.withTheme(MD.withStyles(styles)(DrawerChannelComponent)));
